import styled from "@emotion/styled";

export const Container = styled.div`
  background-color: rgba(243, 245, 248, 1);
  border: 1px solid rgba(228, 231, 236, 1);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;

  & > * {
    transition: all 0.3s ease-in-out;
  }
`;

export const HeaderRow = styled.div`
  color: rgba(74, 84, 102, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  margin: 14px 16px;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: flex-start;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;
`;
